module.exports = __webpack_public_path__ + "static/media/front-end.bed10628.svg";